import React, { useState } from "react";
import { Building2, Check, Mail, MessageSquare, Send, User } from "lucide-react";
import { contact } from "../mock";

const fieldClass =
  "w-full rounded-[20px] border border-white/80 bg-white/72 px-5 py-4 text-[16px] font-medium text-[#16263F] outline-none shadow-[inset_0_1px_0_rgba(255,255,255,0.7),0_10px_28px_rgba(20,40,70,0.05)] transition-all duration-200 placeholder:text-slate-400 focus:border-[#5BA4FB]/70 focus:bg-white focus:shadow-[0_0_0_4px_rgba(91,164,251,0.16),0_12px_32px_rgba(20,40,70,0.08)]";

const ContactSection = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
  };

  return (
    <section id="contact" className="relative scroll-mt-28 overflow-hidden bg-[#EDF1F8] px-6 py-24">
      <div className="pointer-events-none absolute left-[18%] top-24 h-72 w-72 rounded-full bg-white/45 blur-[100px]" />
      <div className="pointer-events-none absolute right-[14%] bottom-10 h-80 w-80 rounded-full bg-[#5BA4FB]/18 blur-[110px]" />

      <div className="relative mx-auto grid max-w-[1180px] grid-cols-1 items-center gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.34em] text-[#5BA4FB]">
            {contact.eyebrow}
          </p>
          <h2 className="mt-5 font-serif text-[11vw] leading-[0.95] tracking-tight text-[#16263F] md:text-[4.8rem]">
            <span className="block">{contact.titleLine1}</span>
            <span className="block italic">{contact.titleLine2}</span>
          </h2>
          <p className="mt-8 max-w-xl text-[17px] leading-8 text-slate-500">
            {contact.description}
          </p>

          <ul className="mt-10 space-y-4">
            {contact.bullets.map((item) => (
              <li key={item} className="flex items-center gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#5BA4FB]/15 text-[#5BA4FB]">
                  <Check className="h-4 w-4" strokeWidth={3} />
                </span>
                <span className="text-[17px] font-semibold text-[#223A5E]">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <form
          onSubmit={handleSubmit}
          className="rounded-[34px] border border-dashed border-[#AFC4DE]/70 bg-white/35 p-5 shadow-[0_28px_80px_rgba(20,40,70,0.09)] backdrop-blur-xl md:p-8"
        >
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <label className="block">
              <span className="mb-2 flex items-center gap-2 text-[14px] font-semibold text-slate-500">
                <User className="h-4 w-4" />
                {contact.form.name}
              </span>
              <input
                className={fieldClass}
                name="name"
                placeholder={contact.form.namePlaceholder}
                type="text"
              />
            </label>

            <label className="block">
              <span className="mb-2 flex items-center gap-2 text-[14px] font-semibold text-slate-500">
                <Mail className="h-4 w-4" />
                {contact.form.email}
              </span>
              <input
                className={fieldClass}
                name="email"
                placeholder={contact.form.emailPlaceholder}
                type="email"
              />
            </label>
          </div>

          <label className="mt-5 block">
            <span className="mb-2 flex items-center gap-2 text-[14px] font-semibold text-slate-500">
              <Building2 className="h-4 w-4" />
              {contact.form.company}
            </span>
            <input
              className={fieldClass}
              name="company"
              placeholder={contact.form.companyPlaceholder}
              type="text"
            />
          </label>

          <label className="mt-5 block">
            <span className="mb-2 flex items-center gap-2 text-[14px] font-semibold text-slate-500">
              <MessageSquare className="h-4 w-4" />
              {contact.form.message}
            </span>
            <textarea
              className={`${fieldClass} min-h-[190px] resize-none leading-7`}
              name="message"
              placeholder={contact.form.messagePlaceholder}
            />
          </label>

          <button
            type="submit"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-[20px] bg-[#16263F] px-6 py-4 text-[16px] font-semibold text-white shadow-[0_16px_36px_rgba(20,40,70,0.22)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#223A5E] active:translate-y-0"
          >
            {submitted ? contact.form.success : contact.form.submit}
            <Send className="h-4 w-4" />
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
